<template>
    <span v-if="value === true" class="text-secondary">Leida</span>
    <span v-else class="text-warning">No leida</span>
</template>

<script>
export default {
    name: 'NotificationStatus',
    props: {
        value: { type: Boolean, required: true },
    },
};
</script>
